import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=6f27b749&scoped=true&"
import script from "./Container.vue?vue&type=script&lang=ts&"
export * from "./Container.vue?vue&type=script&lang=ts&"
import style0 from "./Container.vue?vue&type=style&index=0&id=6f27b749&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f27b749",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CmsComponentsBasicBanner: require('/var/www/packages/theme/components/cms-components/basic-banner/BasicBanner.vue').default})
